export default {

    loading:{
        type:Boolean,
        default: false
    }

}
